

/**
 * The different template types used to download a document
 */
export enum TemplateTypes {
  ConfirmationRdv = 'ConfirmationRdv',
  ConfirmationEditRdv = 'ConfirmationEditRdv',
  ConfirmationDeleteRdv = 'ConfirmationDeleteRdv',



    /** Follow up PDF for a FIT (downloaded by a pharmacist) */
    FollowUpFIT = 'FollowUpFIT',
    /** Follow up PDF for a colo (downloaded by a doctor) */
    FollowUpColo = 'FollowUpColo',
    /** Confirmation PDF for a FIT (downloaded by a participant) */
    ConfirmationFIT = 'ConfirmationFIT',
    /** Confirmation PDF for a colo (downloaded by a participant) */
    ConfirmationColo = 'ConfirmationColo',
    /** Confirmation PDF for a non-participation (downloaded by a participant) */
    ConfirmationNonParticipation = 'ConfirmationNonParticipation',
}

/**
 * These are the types of consultations (ForfaitInclusion)
 */
export enum ConsultationTypes {
  short = 'IncShortConsultation',
  long = 'IncLongConsultation',
  free = 'IncFreeConsultation',
}

/**
 * These are the reasons for a long consultation (LongConsultationReason)
 */
export enum LongConsultationReasons {
  alloPhone = 'PAllophone',
  underGuardianship = 'PSousTutelle',
  traumaticMedicalHistory = 'PAntMedTrauma',
  cognitiveDisorders = 'PTroublesCognitifs',
  mentalDisorders = 'PTroublesPhysique',
  otherReason = 'POtherReason',
}

/**
 * List of all languages in MC-SIS
 */
export enum CorrespondenceLanguages {
  DE,
  EN,
  FR,
  IT,
  RM,
  CS,
  ES,
  HU,
  NL,
  NO,
  PL,
  PT,
  RU,
  SH,
  SI,
  SQ,
  SR,
  TA,
  TR,
}

export enum PhoneNumberCountries {
  CH,
  FR,
  IT,
  DE,
}
